
import md5 from 'js-md5'

export function signMethod(phone, name, timestamp) {
  let key = "C2wocFAAacK5BI8CdvW0DBuxobRpjalYF9LXxYB5QYFhrMeoa5U8UpTSxpoSRwhK"
  let str = phone + name + timestamp + key
  return md5(str)
}

